// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-add"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 11V6H11L9 3.5L2 3.5L2 20H13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20 15V18M20 18V21M20 18H17M20 18H23","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-add',
    ref,
    icon: element,
  },
));

FolderAddIcon.displayName = 'FolderAddIcon';

export default FolderAddIcon;
